import template from './index.pug'
import CallStatusMappingForm from '../components/_form.js'

export default Vue.extend({
  template: template(),
  components: {
    CallStatusMappingForm
  }
})